/**
 * Extracts and returns a user-friendly error message based on the provided error object.
 * @param {object} error - The error object to analyze, typically received from an HTTP request.
 * @returns {string} - String error message.
 */
export default function getHttpErrorMessage(error) {
  let text = 'Something went wrong!'

  if (error.response) {
    text = error.response.statusText

    if (typeof error.response.data !== 'string') {
      if (error.response.data.message) {
        text = error.response.data.message
      } else if (error.response.data.error) {
        if (typeof error.response.data.error === 'string') {
          text = error.response.data.error
        } else if (error.response.data.error?.detail) {
          text = error.response.data.error.detail
        }
      } else if (error.response.data.errors) {
        if (typeof error.response.data.errors === 'string') {
          text = error.response.data.errors
        } else {
          text = error.response.data.errors
            .map((err) => {
              return err.detail || err.title
            })
            .join(' ')
        }
      } else {
        try {
          text = Object.keys(error.response.data)
            .map((field) => {
              const value = error.response.data[field]
              if (typeof value === 'string') return value
              if (Array.isArray(value)) return value.join(', ')
              if (value && typeof value === 'object') {
                return Object.values(value).flat().join(', ')
              }
              return String(value)
            })
            .join('. ')
        } catch {
          text = error.response.statusText || 'Something went wrong!'
        }
      }
    } else if (error.response.status == 404) {
      text = 'Not Found'
    } else if (error.response.status == 403) {
      text = 'Forbidden: Access is denied'
    } else if (error.response.status == 406) {
      text = 'Access is denied'
    }
  } else if (error.request) {
    text = error.message || 'Request failed'
  } else if (error.message) {
    text = error.message
  }

  return text
}
